/** The input data contract this build implements; tests/contract-cases.test.ts asserts it equals contract/VERSION. */
export const CONTRACT_VERSION = '1.12.0';
